/**
 * 排行榜模块
 */
import Mock from 'mockjs'
import cache from '../../common/cache'

// mock 开关
let mock = cache.getSessionData('mock')
let mockSwitch = mock ? '' : '_'

/**
 * 汇总榜单列表
 */
Mock.mock(/used_car\/total_leaderboard/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'date': '2019-04-01',
    'new_tickets_leaderboard': [
      {
        'avatar': 'https://test-images-cdn.cheanjia.com/zhongsheng/image/v1/ixjriiglumdmtmxhcvlqlxzbssgb.jpg',
        'name': '深圳中升星辉奔驰深圳中升星辉奔驰深圳中升星辉奔驰',
        'store': '深圳中升星辉奔驰深圳中升星辉奔驰深圳中升星辉奔驰',
        'new_tickets': 200000,
        'new_tickets_own': 100000
      },
      {
        'avatar': 'https://test-images-cdn.cheanjia.com/zhongsheng/image/v1/fdnydcinidhsalxungbqkvlskzua.jpg',
        'name': 'eden',
        'store': '深圳中升星辉奔驰',
        'new_tickets': 20,
        'new_tickets_own': 10
      },
      {
        'avatar': 'https://test-images-cdn.cheanjia.com/zhongsheng/image/v1/vagzjnrsndixctjvuyayhprnhwia.jpg',
        'name': 'tommy',
        'store': '深圳中升星辉奔驰',
        'new_tickets': 30,
        'new_tickets_own': 5
      }
    ],
    'evaluated_tickets_leaderboard': [
      {
        'avatar': 'https://secure.gravatar.com/avatar/6e219bb202a041dcd709a5aee8b3e88a?s=46&d=identicon',
        'name': 'eden',
        'store': '深圳中升星辉奔驰',
        'evaluated_tickets': 400,
        'evaluated_tickets_own': 2
      },
      {
        'avatar': 'https://secure.gravatar.com/avatar/16e3a04f81a2591afdf4f6310c968c10?s=80&d=identicon',
        'name': 'tommy',
        'store': '深圳中升星辉奔驰',
        'evaluated_tickets': 349,
        'evaluated_tickets_own': 90
      },
      {
        'avatar': 'https://gitlab.lixinio.com/uploads/-/system/user/avatar/8/avatar.png?width=20',
        'name': 'nick',
        'store': '深圳中升星辉奔驰',
        'evaluated_tickets': 68,
        'evaluated_tickets_own': 12
      }
    ],
    'fu_created_rate_leaderboard': [
      {
        'avatar': 'https://secure.gravatar.com/avatar/6e219bb202a041dcd709a5aee8b3e88a?s=46&d=identicon',
        'name': '深圳中升星辉奔驰深圳中升星辉奔驰深圳中升星辉奔驰',
        'fu_created_rate': null
      },
      {
        'avatar': 'https://secure.gravatar.com/avatar/16e3a04f81a2591afdf4f6310c968c10?s=80&d=identicon',
        'name': '深圳中升星辉奔驰',
        'fu_created_rate': 0.56
      },
      {
        'avatar': 'https://gitlab.lixinio.com/uploads/-/system/user/avatar/8/avatar.png?width=20',
        'name': '测试店',
        'fu_created_rate': 0.12
      }
    ],
    'fu_evaluated_rate_leaderboard': [
      {
        'avatar': 'https://secure.gravatar.com/avatar/6e219bb202a041dcd709a5aee8b3e88a?s=46&d=identicon',
        'name': '深圳中升星辉奔驰',
        'fu_evaluated_rate': 0.56
      },
      {
        'avatar': 'https://secure.gravatar.com/avatar/16e3a04f81a2591afdf4f6310c968c10?s=80&d=identicon',
        'name': '深圳中升星辉奔驰',
        'fu_evaluated_rate': 0.56
      },
      {
        'avatar': 'https://gitlab.lixinio.com/uploads/-/system/user/avatar/8/avatar.png?width=20',
        'name': '测试店',
        'fu_evaluated_rate': 0.34
      }
    ]
  }
})

/**
 * 本月个人排行榜列表
 */
Mock.mock(/used_car\/personal_leaderboards\/\d/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': [
    {
      'avatar': 'https://secure.gravatar.com/avatar/6e219bb202a041dcd709a5aee8b3e88a?s=46&d=identicon',
      'name': '深圳中升星辉奔驰深圳中升星辉奔驰深圳中升星辉奔驰',
      'store': '深圳中升星辉奔驰深圳中升星辉奔驰深圳中升星辉奔驰',
      'new_tickets': 20,
      'new_tickets_own': 10,
      'evaluated_tickets': 30,
      'evaluated_tickets_own': 3,
      'inbound_cars': 10,
      'inbound_cars_own': 5
    },
    {
      'avatar': 'https://secure.gravatar.com/avatar/16e3a04f81a2591afdf4f6310c968c10?s=80&d=identicon',
      'name': 'eden',
      'store': '深圳中升星辉奔驰',
      'new_tickets': 20,
      'new_tickets_own': 10,
      'evaluated_tickets': 30,
      'evaluated_tickets_own': 3,
      'inbound_cars': 10,
      'inbound_cars_own': 5
    },
    {
      'avatar': 'https://gitlab.lixinio.com/uploads/-/system/user/avatar/8/avatar.png?width=20',
      'name': 'tommy',
      'store': '深圳中升星辉奔驰',
      'new_tickets': 30,
      'new_tickets_own': 5,
      'evaluated_tickets': 30,
      'evaluated_tickets_own': 3,
      'inbound_cars': 10,
      'inbound_cars_own': 5
    },
    {
      'avatar': 'https://secure.gravatar.com/avatar/6e219bb202a041dcd709a5aee8b3e88a?s=46&d=identicon',
      'name': 'eden',
      'store': '深圳中升星辉奔驰',
      'new_tickets': 20,
      'new_tickets_own': 10,
      'evaluated_tickets': 30,
      'evaluated_tickets_own': 3,
      'inbound_cars': 10,
      'inbound_cars_own': 5
    },
    {
      'avatar': 'https://secure.gravatar.com/avatar/16e3a04f81a2591afdf4f6310c968c10?s=80&d=identicon',
      'name': 'eden',
      'store': '深圳中升星辉奔驰',
      'new_tickets': 20,
      'new_tickets_own': 10,
      'evaluated_tickets': 30,
      'evaluated_tickets_own': 3,
      'inbound_cars': 10,
      'inbound_cars_own': 5
    },
    {
      'avatar': 'https://gitlab.lixinio.com/uploads/-/system/user/avatar/8/avatar.png?width=20',
      'name': 'tommy',
      'store': '深圳中升星辉奔驰',
      'new_tickets': 30,
      'new_tickets_own': 5,
      'evaluated_tickets': 30,
      'evaluated_tickets_own': 3,
      'inbound_cars': 10,
      'inbound_cars_own': 5
    }
  ],
  'total_evaluators': 60
})

/**
 * 本月个人排行榜列表
 */
Mock.mock(/used_car\/store_leaderboards\/\d/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': [
    {
      'avatar': 'https://secure.gravatar.com/avatar/6e219bb202a041dcd709a5aee8b3e88a?s=46&d=identicon',
      'name': '深圳中升星辉奔驰深圳中升星辉奔驰深圳中升星辉奔驰',
      'fu_count': 100000,
      'car_visits_own': 200000,
      'new_tickets': 20,
      'new_tickets_own': 10,
      'evaluated_tickets': 30,
      'evaluated_tickets_own': 3,
      'inbound_cars': 10,
      'inbound_cars_own': 5,
      'fu_created_rate': 0.68,
      'fu_evaluated_rate': 1.45
    },
    {
      'avatar': 'https://secure.gravatar.com/avatar/16e3a04f81a2591afdf4f6310c968c10?s=80&d=identicon',
      'name': '深圳中升星辉奔驰',
      'fu_count': 10,
      'car_visits_own': 20,
      'new_tickets': 20,
      'new_tickets_own': 10,
      'evaluated_tickets': 30,
      'evaluated_tickets_own': 3,
      'inbound_cars': 10,
      'inbound_cars_own': 5,
      'fu_created_rate': null,
      'fu_evaluated_rate': 0
    },
    {
      'avatar': 'https://gitlab.lixinio.com/uploads/-/system/user/avatar/8/avatar.png?width=20',
      'name': '深圳中升星辉奔驰',
      'fu_count': 10,
      'car_visits_own': 20,
      'new_tickets': 20,
      'new_tickets_own': 10,
      'evaluated_tickets': 30,
      'evaluated_tickets_own': 3,
      'inbound_cars': 10,
      'inbound_cars_own': 5,
      'fu_created_rate': 0.68,
      'fu_evaluated_rate': 1.45
    },
    {
      'avatar': 'https://secure.gravatar.com/avatar/6e219bb202a041dcd709a5aee8b3e88a?s=46&d=identicon',
      'name': '深圳中升星辉奔驰',
      'fu_count': 10,
      'car_visits_own': 20,
      'new_tickets': 20,
      'new_tickets_own': 10,
      'evaluated_tickets': 30,
      'evaluated_tickets_own': 3,
      'inbound_cars': 10,
      'inbound_cars_own': 5,
      'fu_created_rate': 0.68,
      'fu_evaluated_rate': 1.45
    },
    {
      'avatar': 'https://secure.gravatar.com/avatar/16e3a04f81a2591afdf4f6310c968c10?s=80&d=identicon',
      'name': '深圳中升星辉奔驰',
      'fu_count': 10,
      'car_visits_own': 20,
      'new_tickets': 20,
      'new_tickets_own': 10,
      'evaluated_tickets': 30,
      'evaluated_tickets_own': 3,
      'inbound_cars': 10,
      'inbound_cars_own': 5,
      'fu_created_rate': 0.68,
      'fu_evaluated_rate': 1.45
    },
    {
      'avatar': 'https://gitlab.lixinio.com/uploads/-/system/user/avatar/8/avatar.png?width=20',
      'name': '深圳中升星辉奔驰',
      'fu_count': 10,
      'car_visits_own': 20,
      'new_tickets': 20,
      'new_tickets_own': 10,
      'evaluated_tickets': 30,
      'evaluated_tickets_own': 3,
      'inbound_cars': 10,
      'inbound_cars_own': 5,
      'fu_created_rate': 0.68,
      'fu_evaluated_rate': 1.45
    }
  ],
  'total_stores': 60
})
